export const getStatusReport = `
    query getStatusReport(
            $start_date: String!,
            $end_date: String!,
            $teams: [Int],
            $courses: [Int],
            $events: [Int],
            $mode: String,
            $page: Int,
            $sort_by: String,
            $sort_dir: String) {
        statusReport(
            start_date: $start_date,
            end_date: $end_date,
            teams: $teams,
            courses: $courses,
            events: $events,
            mode: $mode,
            page: $page,
            sort_dir: $sort_dir,
            sort_by: $sort_by
        ) {
            data {
                id
                status
                status_name
                lock
                enter
                exit
                percentage
                created_at
                student {
                    uuid
                    first_name
                    last_name
                    teams {
                        name
                    }
                }
                attendable {
                    ... on Course {
                        title
                    }
                    ... on Event {
                        title
                    }
                }
            }
            total
        }
    }
`
export const getTokenReport = `
    query getTokenReport(
            $teams: [Int]!,
            $courses: [Int]!,
            $page: Int!,
            $sort_by: String,
            $sort_dir: String) {
        tokenReport(
            teams: $teams,
            courses: $courses,
            page: $page,
            sort_dir: $sort_dir,
            sort_by: $sort_by
        ) {
            data {
                id
                uuid
                first_name
                last_name
                token
            }
            total
        }
    }
`
export const getEventReport = `
    query getEventReport(
            $uuid: String!,
            $page: Int!,
            $sort_by: String,
            $sort_dir: String) {
        eventReport(
            uuid: $uuid,
            page: $page,
            sort_dir: $sort_dir,
            sort_by: $sort_by
        ) {
            data {
                student {
                    uuid
                    first_name
                    last_name
                    email
                }
                in_waitlist
            }
            total
        }
    }
`
export const getBeaconReport = `
    query getBeaconReport(
            $page: Int!,
            $sort_by: String,
            $sort_dir: String) {
        beaconReport(
            page: $page,
            sort_dir: $sort_dir,
            sort_by: $sort_by
        ) {
            data {
                factory_id
                name
                battery
                location{
                    name
                }
            }
            total
        }
    }
`
export const getClassReport = `
    query getCourseReport(
            $uuid: String!,
            $page: Int!,
            $sort_by: String,
            $sort_dir: String) {
        courseReport(
            uuid: $uuid,
            page: $page,
            sort_dir: $sort_dir,
            sort_by: $sort_by
        ) {
            data {
                student {
                    uuid
                    first_name
                    last_name
                }
                present_count
                absent_count
                excused_count
                total_count
                percentage
            }
            total
        }
    }
`
export const getLastAttendanceReport = `
    query getLastAttendanceReport(
            $teams: [Int]!,
            $course_id: Int,
            $page: Int!,
            $sort_by: String,
            $sort_dir: String) {
        lastAttendanceReport(
            teams: $teams,
            course_id: $course_id,
            page: $page,
            sort_dir: $sort_dir,
            sort_by: $sort_by
        ) {
            data {
                id
                uuid
                first_name
                last_name
                last_seen
            }
            total
        }
    }
`
export const getStudentReport = `
    query getStudentReport($uuid: String!) {
        student(uuid: $uuid) {
            uuid
            course_report {
                uuid
                title
                identifier
                present_count
                absent_count
                excused_count
                total_count
                percentage
                last_seen
            }
            event_report {
                uuid
                title
                identifier
                present_count
                absent_count
                excused_count
                total_count
                percentage
            }
        }
    }
`
export const getSetupReport = `
    query getSetupReport(
            $mode: String!,
            $page: Int!,
            $sort_by: String,
            $sort_dir: String) {
        setupReport(
            mode: $mode,
            page: $page,
            sort_dir: $sort_dir,
            sort_by: $sort_by
        ) {
            data {
                id
                uuid
                first_name
                last_name
                token
                last_seen
                semester_apa
                device {
                    os_version
                    app_version
                    model_name
                    location_permission
                }
            }
            total
        }
    }
`

export const getCancellationReport = `
    query getCancellationReport(
            $start_date: String!,
            $end_date: String!,
            $page: Int,
            $sort_by: String,
            $sort_dir: String) {
        cancellationReport(
            start_date: $start_date,
            end_date: $end_date,
            page: $page,
            sort_dir: $sort_dir,
            sort_by: $sort_by
        ) {
            data {
                id
                date
                notes
                created_at
                course_id
                course {
                    id
                    uuid
                    title
                    crn
                }
            }
            total
        }
    }
`